import type { InfiniteData } from "@reduxjs/toolkit/query/react"
import type { CursorPage } from "./model"
import type { Entity, UpdateableEntity } from "@/utils"
import { isAfter } from "@/utils"

export type Pages<TItem> = InfiniteData<CursorPage<TItem>, string | null>

/** Replaces a loaded row with a newer version; fields the update lacks keep their cached value. */
export const patchRow = <TItem extends UpdateableEntity>(
  pages: Pages<TItem>,
  update: TItem,
) => {
  pages.pages.forEach((page) => {
    const row = page.items.find(({ id }) => id === update.id)
    if (row && isAfter(update.updatedAt, row.updatedAt)) {
      Object.assign(row, update)
    }
  })
}

export const removeRow = <TItem extends Entity>(
  pages: Pages<TItem>,
  id: TItem["id"],
) => {
  pages.pages.forEach((page) => {
    page.items = page.items.filter((row) => row.id !== id)
  })
}
